export const id = {
    "TRIGGER_LISTEN": "Mendengarkan pemicu",
    "ASSIST_EMPTY_MSG": "Agen AI sedang mendengarkan percakapan Anda dan siap membantu secara otomatis saat dipicu.",
    "MYBOT_TRIGGET_LISTEN": "Tidak ada tugas aktif di My Bot saat ini",
    "MYBOT_EMTPY_MSG": "Untuk memulai tugas di My Bot, pergi ke tab pencarian dan pilih opsi \"Jalankan dengan masukan agen\" untuk tugas yang diinginkan.",
    "PROACTIVE_MODE": "Mode Proaktif",
    "SETTINGS": "Pengaturan",
    "HELP_AND_SUPPORT": "Bantuan dan Dukungan",
    "HELP": "Bantuan",
    "LANGUAGE": "Bahasa",
    "THEME": "Tema",
    "AUTOMATIC": "Otomatis",
    "AUTO_SCROLL_TOOLTIP":"Mengontrol gulir otomatis Tab Bantuan, Bot saya & Konten Tab Transkrip",
    "DARK": "Gelap",
    "FILE_NAME":"Nama file",
    "LIGHT": "Terang",
    "THEME_DESC": "Ini akan menggunakan mode default sistem Anda",
    "DOCUMENTATION": "Dokumentasi",
    "DOC_DESC": "Periksa artikel dokumentasi mendalam kami.",
    "FAQ_U": "FAQ",
    "FAQ_DESC": "Periksa pertanyaan yang sering diajukan tentang Agen AI.",
    "KORE_ACADEMY": "Akademi Kore",
    "KORE_ACA_DESC": "Pelajari lebih lanjut tentang Agen AI melalui kursus akademi.",
    "SEARCH": "Cari",
    "MY_BOT": "Bot Saya",
    "ASSIST": "Bantu",
    "TRANSCRIPT": "Transkrip",
    "HISTORY": "Riwayat",
    "STARTOVER": "Mulai ulang",
    "RESTART_INPUTS": "Mulai ulang dengan masukan yang ditangkap",
    "ASKCUSTOMER": "Tanya Pelanggan",
    "TELLCUSTOMER": "Katakan kepada Pelanggan",
    "TAB_TEXT":"Tidak ada tab yang diaktifkan! Harap aktifkan setidaknya satu tab",
    "WELCOME_MSG": "Pesan Selamat Datang",
    "TAP_SEARCH":"Ketuk untuk mencari",
    "SEND": "Kirim",
    "SENT": "Terkirim",
    "AWAITING": "Menunggu Tanggapan | Ketik untuk melanjutkan",
    "OVERRIDE": "Ketik untuk melanjutkan",
    "OVERRIDE_FILE": "Lampirkan File untuk melanjutkan",
    "ACCEPT_RESPONSE": "Tanggapan Diterima",
    "AGENT_ENTERED": "Agen Masuk",
    "EXPECTED_FORMAT": "Format yang Diharapkan",
    "INPUT_VALUES": "Nilai Masukan",
    "RESTART": "Mulai ulang",
    "START_OVER": "Mulai ulang",
    "RESTART_CAPTURE": "Mulai ulang dengan masukan yang ditangkap",
    "CANCEL": "Batal",
    "INTERRUPT_DIALOG": "TUGAS DIALOG DITRANSPIRKAN",
    "RUN": "JALANKAN",
    "RUN_AGENT": "Jalankan dengan Masukan Agen",
    "STEP": "Langkah",
    "DIALOG_TASK": "Tugas Dialog",
    "FAQ": "FAQ",
    "SNIPPET": "Jawaban",
    "ARTICLE": "Halaman Web",
    "FILE": "File",
    "SUGGESTED": "Disarankan",
    "ALL_DIALOG": "Semua Tugas Dialog",
    "DIALOG_TEXT": "Dialog",
    "INTENT_IDENTIFIED": "Ujaran Pelanggan",
    "NOT_WHAT_LOOKING": "Saran Salah?",
    "BOT": "Bot",
    "CUSTOMER": "Pelanggan",
    "YOU": "Anda",
    "TERMINATE_CONV": "Akhiri Tugas Dialog",
    "TERMINATE_CONV_DESC": "Apakah Anda yakin ingin mengakhiri tugas dialog? Agen AI tidak akan dapat memberikan saran lebih lanjut.",
    "YES_TERMINATE": "Ya, Akhiri",
    "NO_CANCEL": "Tidak, Batalkan",
    "OVERRIDE_CONTINUE": "Lanjutkan dengan mode timpa",
    "SUMMARY_TEXT": "Ringkasan",
    "SUBMIT": "Kirim",
    "INTERRUPT_OCCURED": "Interupsi Terjadi",
    "IDENTIFIED_INTENT": "Niat Teridentifikasi",
    "INTERRUPT_DESC": "Menjalankan ini akan mengakhiri Tugas Dialog yang sedang berlangsung.",
    "ACCEPT_RUN": "Terima dan Jalankan",
    "RUN_LATER": "Jalankan Nanti",
    "KNOW_MORE": "Ketahui Lebih Lanjut",
    "MORE_TEXT": "Lebih",
    "LESS_TEXT": "Kurang",
    "VIEW_MORE": "Lihat Lebih Banyak",
    "VIEW_LESS": "Lihat Lebih Sedikit",
    "SHOW_MORE_FAQ": "Tampilkan lebih banyak FAQ",
    "SHOW_LESS_FAQ": "Tampilkan lebih sedikit FAQ",
    "SHOW_MORE_ARTICLE": "Tampilkan lebih banyak halaman web",
    "SHOW_LESS_ARTICLE": "Tampilkan lebih sedikit halaman web",
    "SHOW_MORE_SNIPPET": "Tampilkan lebih banyak Jawaban",
    "SHOW_LESS_SNIPPET": "Tampilkan lebih sedikit Jawaban",
    "SHOW_MORE_FILES": "Tampilkan Lebih Banyak File",
    "SHOW_LESS_FILES": "Tampilkan Lebih Sedikit File",
    "VIEW_ALL_DIALOG": "Lihat Semua Dialog",
    "VIEW_FEW_DIALOG": "Lihat Beberapa Dialog",
    "HELP_FULL": "Bermanfaat?",
    "THANKYOU": "Terima Kasih!",
    "EXPAND_MORE": "Perluas / Lebih",
    "CLOSE_TEXT": "Tutup",
    "STARTED": "Dimulai",
    "ENDED": "Diakhiri",
    "VIEW_FULL_ARTICLE": "Lihat halaman web",
    "VIEW_FULL_FILE": "Lihat file",
    "COPIED": "Disalin",
    "SENTI_ANALY": "Analisis Sentimen",
    "WRONG_SUGGESTION": "Saran Salah",
    "INCORRECT_INTENT": "Niat Salah",
    "ACCIDENTAL_CLICK": "Klik Tidak Sengaja",
    "TIME_TAKING": "Mengambil Waktu",
    "OTHER": "Lainnya",
    "PLAYBOOK_EMPTY_MSG": "Pilih Buku Putih",
    "PLAYBOOK_EMPTY_DESC": "Agen AI tidak dapat memuat buku putih karena semua buku putih yang tersedia bersifat dinamis. Klik 'Pilih Buku Putih' untuk mengakses buku putih",
    "STAGE": "Tahap",
    "PROCEED_TO_CLOSE": "Lanjutkan untuk menutup",
    "RECOMENDED_PLAYBOOK": "BUKU PUTIH YANG DIREKOMENDASIKAN",
    "PRIMARY_SCRIPTS": "SKRIP UTAMA",
    "DYNAMIC_SCRIPTS": "SKRIP DINAMIS",
    "RESUME": "Lanjutkan",
    "ENABLE_CLOSE": "Klik tombol lanjutkan untuk menutup untuk mengaktifkan tahap penutupan",
    "LIST_VIEW": "Tampilan Daftar",
    "TERMINATE": "Akhiri",
    "MINIMIZE": "Kecilkan",
    "MAXIMIZE": "Maksimalkan",
    "NO_SEARCH_RESULT": "Tidak ada hasil pencarian ditemukan",
    "SENTIMENT_AWAITING": "Menunggu analisis sentimen",
    "POSITIVE": "Positif",
    "NEGATIVE": "Negatif",
    "ASSOCIATED_WORK_NOTES": "Catatan Solusi Sebelumnya",
    "AGENT_JOINED_CONV": "Agen bergabung dengan percakapan",
    "AUTOSCROLL_ASSIST": "Gulir Otomatis Konten Tab Bantuan",
    "FILE_SIZE_MSG": "Ukuran file harus hingga 25MB. Silakan coba lagi.",
    "OVERRIDE_BTN": "Tindakan",
    "CHOOSE_FILE": "Pilih File",
    "SUMMARY_ERROR_TEXT": "Maaf, tetapi terjadi masalah saat menghasilkan ringkasan percakapan ini. Silakan buat ringkasan Anda sendiri.",
    "ASK_A_QUESTION": "Ajukan Pertanyaan",
    "COPY": "Salin",
    "TELL_US_MORE": "Ceritakan lebih banyak…",
    "THANKS_FEEDBACK": "Terima kasih atas masukan Anda",
    "SOMETHING_WRONG": "Sesuatu yang salah",
    "PLAYBOOK": "Buku petunjuk",
    "CLICK_ERROR_DETAILS": "Klik untuk melihat detail kesalahan",
    "NO_ACTIVE_PLAYBOOK": "Tidak ada playbook aktif",
    "REPHRASE_QUESTION": "Bisakah Anda menyusun ulang pertanyaan Anda atau bertanya tentang hal lain?",
    "INTERNAL_INFO": "Informasi internal",
    "SOURCES": "Sumber",
    "CONVERSATION_SUMMARY": "Ringkasan percakapan",
    "WAITING": "Menunggu",
    "WIDGET_DISABLED": "Widget dinonaktifkan",
    "AI_SETTINGS_DISABLED": "Pengaturan AI dinonaktifkan! Silakan hubungi administrator AI",
    "SERVER_CONNECTION_ERROR": "Kesalahan saat menghubungkan ke server",
    "VIEW": "Lihat",
    "ATTACHMENT_INPUT": "Input lampiran",
    "TYPE_SUMMARY": "Ketik ringkasan",
    "VIEW_FULL_ARTICLE_2": "Lihat artikel lengkap",
    "VIEW_FULL_FILE_2": "Lihat file lengkap",
    "BY":"Oleh",
    GENERATE_SUMMARY: "Buat Ringkasan",
    PREV_SUMMARIES: "Ringkasan yang Dihasilkan Sebelumnya",
    DIALOG_WORKFLOWS: "Alur Kerja Dialog",
    SHOW_ALL_DIALOG: "Tampilkan semua Tugas Dialog",
    SHOW_ALL_DIALOGS: "Tampilkan Semua Dialog",
    CUSTOM_TAB: "Tab Kustom",
    AGENT_INPUT: "Masukan Agen",
    "CUSTOM_EMPTY_MSG" : "Tidak ada alur kerja aktif saat ini",
    "CUSTOM_TAB_DESC" : "Untuk memulai alur kerja, jalankan salah satu dari daftar yang ada di bagian bawah layar.",
    "SUBMIT_OVERALL_FEEDBACK" : "Kirimkan umpan balik keseluruhan",
    "FEEDBACK_POPUP_SUBTITLE" : "Umpan balik tentang widget dan fiturnya",
    "FEEDBACK_SATISFIED" : "Puas",
    "FEEDBACK_UNSATISFIED" : "Tidak puas",
    "FEEDBACK_PROVIDE_REASONS" : "Berikan alasan lebih lanjut…",
    "FEEDBACK_TITLE" : "Umpan balik",
    "AGENTIC_THINKING" : "Berpikir",
    "AGENTIC_AGENT_TITLE" : "Agen",
    "AGENTIC_COPILOT_MODE_TITLE" : "Mode Copilot Agens",
    "AGENTIC_SENDING_MESSAGE" : "Mengirim...",
    "AGENTIC_COPILOT_DESC" : "Agentic Copilot secara aktif mendengarkan percakapan Anda dan siap membantu secara otomatis",
    "AGENTIC_SEARCH_RESULTS" : "Hasil Agen",
    "PAUSE_AUTO_SEND" : "Jeda Kirim Otomatis",
    "PAUSE_AGENTIC" : "Jeda Agen",
    "RESUME_AGENTIC" : "Lanjutkan Agen",
    "RESUME_AUTO_SEND" : "Lanjutkan Kirim Otomatis"
}